import { useState } from "react";
import { useApp } from "../context/AppContext";
import AuthorPageGenerator from "./AuthorPageGenerator";
import BlogTemplateGenerator from "./BlogTemplateGenerator";

// Модуль «Розмітка для сторінок блогу» — два генератори готової розмітки:
// сторінка автора (E-E-A-T) і шаблон статті (HTML + Schema + markdown для AI).
export default function SchemaView() {
  const { proj, t, card, btnP } = useApp();
  const [authorGen, setAuthorGen] = useState(false);
  const [blogGen, setBlogGen] = useState(false);

  if (!proj) return null;

  const tiles = [
    {
      open: () => setAuthorGen(true),
      icon: "👤",
      accent: "#6366f1",
      title: "Сторінка автора",
      desc: "Профіль експерта для E-E-A-T: готова верстка + Schema (ProfilePage / Person). Публікується на author.house, а URL автоматично йде у sameAs ваших сторінок.",
      points: ["ProfilePage + Person · hasCredential, knowsAbout", "Публікація на author.house одним кліком", "URL профілю → у sameAs і @id статей"],
      cta: "Створити сторінку автора",
    },
    {
      open: () => setBlogGen(true),
      icon: "📝",
      accent: "#a855f7",
      title: "Шаблон статті блогу",
      desc: "Готова розмітка статті для вставки в сайт. Автор уже прив'язаний, місця для заміни розробником помічені {{плейсхолдерами}}.",
      points: ["HTML + Schema: BlogPosting, FAQPage, BreadcrumbList", "Markdown-версія з YAML-метаданими для AI-видачі", "Посилання на автора + зв'язка сутностей @id"],
      cta: "Відкрити шаблон статті",
    },
  ];

  return (
    <div>
      {authorGen && <AuthorPageGenerator onClose={() => setAuthorGen(false)} />}
      {blogGen && <BlogTemplateGenerator onClose={() => setBlogGen(false)} />}

      <div style={{ marginBottom: 4 }}>
        <h2 style={{ fontSize: 22, fontWeight: 800, margin: 0 }}>Розмітка для сторінок блогу</h2>
        <p style={{ fontSize: 13.5, color: t.textMuted, margin: "7px 0 0", maxWidth: 720, lineHeight: 1.6 }}>
          Генератори готової розмітки для блогу: сторінка автора (E-E-A-T) і шаблон статті зі Schema + markdown для AI-видачі.
          Налаштовуєте, копіюєте — і вставляєте в сайт.
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 16, marginTop: 22 }}>
        {tiles.map((tile, i) => (
          <div key={i} onClick={tile.open}
            style={{ ...card, cursor: "pointer", padding: 26, overflow: "hidden", transition: "transform .18s, box-shadow .18s", borderTop: `3px solid ${tile.accent}` }}
            onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 16px 44px -20px rgba(99,102,241,.55)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
            <div style={{ width: 52, height: 52, borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, background: `${tile.accent}1f`, marginBottom: 16 }}>{tile.icon}</div>
            <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 6 }}>{tile.title}</div>
            <p style={{ fontSize: 13, color: t.textMuted, lineHeight: 1.6, margin: "0 0 14px" }}>{tile.desc}</p>
            <ul style={{ listStyle: "none", padding: 0, margin: "0 0 20px" }}>
              {tile.points.map((p, j) => (
                <li key={j} style={{ fontSize: 12.5, color: t.text, display: "flex", gap: 8, alignItems: "flex-start", marginBottom: 7 }}>
                  <span style={{ color: tile.accent, fontWeight: 800, flexShrink: 0 }}>✓</span>
                  <span>{p}</span>
                </li>
              ))}
            </ul>
            <button onClick={(e) => { e.stopPropagation(); tile.open(); }} style={{ ...btnP, fontSize: 13 }}>{tile.cta} →</button>
          </div>
        ))}
      </div>
    </div>
  );
}
